import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M20 40c2.446 0 4.79-.44 6.956-1.244L27.826 20l-.87-18.756A19.958 19.958 0 0 0 20 0c-2.447 0-4.79.44-6.957 1.244L12.174 20l.87 18.756A19.955 19.955 0 0 0 20 40Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#A2001D",
  d: "M0 20c0 8.6 5.427 15.93 13.043 18.756V1.244C5.428 4.07 0 11.401 0 20ZM26.956 1.244v37.512C34.572 35.93 40 28.599 40 20c0-8.6-5.428-15.93-13.044-18.756Z"
}, null, -1), h = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M9.565 20h1.74v6.956h-1.74V20Zm-6.956 0h1.739v6.956h-1.74V20Zm4.347 4.348a1.74 1.74 0 1 0 0-3.478 1.74 1.74 0 0 0 0 3.478Zm0-6.957a.87.87 0 1 0 0-1.739.87.87 0 0 0 0 1.74Zm-1.739 7.826h3.479v1.74H5.217v-1.74Zm0-6.957h3.479V20H5.217v-1.74Zm1.739-7.825.616 1.895h1.993l-1.612 1.171.615 1.896-1.612-1.172-1.612 1.172.616-1.896-1.612-1.17H6.34l.616-1.896Z"
}, null, -1), s = [
  n,
  c,
  h
];
function i(d, m) {
  return e(), l("svg", o, [...s]);
}
const _ = { render: i };
export {
  _ as default,
  i as render
};
